import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-259a012f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anmly-side-bar-actions-box" }

import RexSortFieldV3 from '@/rex-components/RexSortFieldV3.vue';
import RexFilterFieldV3 from '@/rex-components/RexFilterFieldV3.vue';
import { anomalyFilterOptions } from '@/components/charts/utils/utils.config';

interface Props {
  selectedFilters: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AnomalySideBarActions',
  props: {
    selectedFilters: {}
  },
  emits: ['onAnomalySort', 'onAnomalyFilter'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RexFilterFieldV3, {
      initialSelectedKeys: props.selectedFilters,
      items: _unref(anomalyFilterOptions),
      onOnFilter: _cache[0] || (_cache[0] = (selectedKeys) => emit('onAnomalyFilter', selectedKeys)),
      class: "anmly-side-bar-filter-action"
    }, null, 8, ["initialSelectedKeys", "items"]),
    _createVNode(RexSortFieldV3, {
      onOnSortChange: _cache[1] || (_cache[1] = (isAsc) => emit('onAnomalySort', isAsc))
    })
  ]))
}
}

})